import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CoreaiService } from './services/coreai.service';
import { AuthService } from './services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { delay, distinctUntilChanged, filter, firstValueFrom, map, Observable, skip, Subscription, switchMap, tap, timer } from 'rxjs';
import { TimetrackService } from './services/timetrack.service';
import { TabService } from './services/tab.service';
import { LoaderService } from './services/loader.service';
// import { SwUpdate } from '@angular/service-worker';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { OktaService } from './services/okta.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  currentEnv = environment.deployment;
  title = 'playground';
  currentUrl!: string;
  private alive = true;
  isTabActive: boolean = false;
  startTime: any;
  endTime: any;
  status: any;
  feature: any;
  usageTime: any;
  sessionTimeLeft: any;
  accessT: any;
  OHR: any;
  isLoading: boolean = true;
  private tabActiveSub!: Subscription;
  private navigationSub!: Subscription;
  isAuthenticated$: Observable<boolean>;
  updateAvailable: boolean = false;
  authSuccessful = false;
  constructor(
    private authService: AuthService,
    private oktaService: OktaService,
    private coreAIService: CoreaiService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private timeTrackService: TimetrackService,
    private tabService: TabService,
    private loaderService: LoaderService,
    private coraiService: CoreaiService,
    private updates: SwUpdate
  ) {
    this.isLoading = false;
    this.updateToken();

    this.isAuthenticated$ = this.oktaService.isAuthenticated$()


    if (this.updates.isEnabled) {
      this.checkForUpdates();
    }


    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    //this.loaderService.show();
    // this.isLoading = true;
  }


  async ngOnInit() {

    /* this.isAuthenticated$
     .pipe(
       skip(1), // Ignore the first response
       distinctUntilChanged(), // Only subscribe when the value changes
       switchMap((isAuthenticated) => {
         if (!isAuthenticated) {
           console.log('User is not authenticated:', isAuthenticated);
           this.login();
           return timer(60000).pipe(switchMap(() => [isAuthenticated])); // Ignore new values for 1 minute
         } else {
           console.log('User is authenticated:', isAuthenticated);
           return [isAuthenticated];
         }
       })
         
     )
     .subscribe(); 
     */


    if (this.oktaService.isLoginRedirect()) {
      await this.handleCallback();
    } else {
      const isAuthenticated = await this.oktaService.checkAuthentication();
      if (!isAuthenticated) {
        console.log('User not authenticated. Redirecting to login...');
        await this.oktaService.login();
      } else {
        this.authSuccessful = true;
        console.log('User authenticated. Proceeding normally.');
        //this.redirectToLastURI();
      }
    }

    if(this.currentEnv != 'PROD'){
      await this.getCorAiAccessToken();
    }else{
      await this.getCoreAIuserDetail();
    }
    
  }



  public checkForUpdates(): void {
    this.updates.versionUpdates.pipe(
      // Only proceed when VERSION_READY event occurs
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      // Transform the event data
      map(evt => ({
        type: 'UPDATE_AVAILABLE',
        current: evt.currentVersion,
        available: evt.latestVersion
      }))
    ).subscribe({
      next: (evt) => {
        console.log('Current version:', evt.current);
        console.log('Available version:', evt.available);
        this.promptUser();
      },
      error: (err) => console.error('Error checking updates:', err)
    });
  }

  async updateToken() {
    try {
      let userInfo: any = await this.authService.getUserInfo();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error:', error);
    }
  }


  private promptUser(): void {
    this.updateAvailable = true;
  }



  async getCoreAIuserDetail() {
    await this.coreAIService.fetchAndUpdateUserDetail();

  }

  async getCorAiAccessToken() {
    this.coraiService.getAccessToken().subscribe(async (res: any) => {
      console.log("Getting Core AI Access Token")
      if (res?.access_token) {
        localStorage.setItem('corai_token', res?.access_token);
        this.cdr.detectChanges();
        await this.getCoreAIuserDetail();
      }
    })
  }




  async updateApp(): Promise<void> {
    try {
      // Unregister existing service worker
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(registration => registration.unregister()));
        console.log('Service workers unregistered');
      }

      // Clear caches
      if ('caches' in window) {
        const keys = await window.caches.keys();
        await Promise.all(keys.map(key => window.caches.delete(key)));
        console.log('Caches cleared');
      }

      // Activate update
      await this.updates.activateUpdate();
      console.log('Update activated');

      // Reload the page
      window.location.reload();
    } catch (err) {
      console.error('Failed to update:', err);
    }
  }


  private async authenticate(): Promise<void> {
    this.authSuccessful = await firstValueFrom(
      this.isAuthenticated$.pipe(distinctUntilChanged())
    );

    if (!this.authSuccessful) {
      console.log('User is not authenticated. Redirecting to login...');
      await this.handleLogin();
    } else {
      if (this.oktaService.isLoginRedirect()) {
        console.log('Detected login redirect. Handling callback...');
        await this.handleCallback();
      } else {
        console.log('No login redirect detected. Proceeding normally.');
      }
    }
  }

  private async handleCallback(): Promise<void> {
    try {
      // Handle Okta tokens
      await this.oktaService.handleCallback();

      // Get the original URI saved during login or default to '/'
      this.redirectToLastURI();
    } catch (error) {
      console.error('Callback handling error:', error);

      // Fallback to a safe route
      await this.router.navigate(['/']);
    }
  }

  private async redirectToLastURI() {
    const originalUri = this.oktaService.getOriginalUri() || '/';
    console.log("This is the original uri", originalUri)
    // Clear the original URI after handling
    const path = this.extractPathFromUri(originalUri);
    console.log('Extracted path:', path);
    this.oktaService.clearOriginalUri();

    // Navigate to the original URI 
    await this.router.navigate([path]);
  }

  private extractPathFromUri(uri: string): string {
    try {
      const url = new URL(uri, window.location.origin); // Use window.location.origin as a base
      return url.pathname; // Extract only the path (e.g., /path)
    } catch (error) {
      console.error('Error extracting path from URI:', error);
      return '/'; // Fallback to '/'
    }
  }

  async handleLogin() {
    try {
      await this.oktaService.login();
    } catch (error) {
      console.error('Login error:', error);
      // Handle login error (could show error message)
    }
  }

  login() {
    // Trigger the login method
    this.oktaService.login();
    // window.location.reload();
  }

  logout() {
    // Trigger the logout method
    this.oktaService.logout();
  }


  // User Metrix Logs

  UpdateUserLogs() {
    this.feature = 'playground';
    this.tabActiveSub = this.tabService.isTabActive().subscribe(isActive => {
      if (isActive) {
        this.isTabActive = true;
        this.status = 'check-in';
        this.startTime = new Date();
        this.endTime = null;
        this.usageTime = 0;
        console.log('Tab is active');
        this.sendLogs();
      } else {
        this.isTabActive = false;
        this.status = 'check-out';
        this.endTime = new Date();
        this.usageTime = (this.endTime.getTime() - this.startTime.getTime()) / 1000;
        console.log('Tab is not active');
        this.sendLogs();
      }
    });
    this.navigationSub = this.timeTrackService.navigation$.subscribe(navigation => {
      this.status = navigation.status;
      this.startTime = navigation.start_time;
      this.endTime = navigation.end_time;
      this.feature = navigation.feature;
      this.usageTime = navigation.usage_time;
      this.sendLogs();
    });
  }

  sendLogs() {
    let userDetail: string = localStorage.getItem('user_detail') || '{}';
    let parseDetail = JSON.parse(userDetail);
    const payload = {
      user_id: this.authService.getOHR(),
      platform: 'desktop',
      feature_name: this.feature,
      location: parseDetail?.time_zone,
      feature_start_time: this.startTime,
      feature_end_time: this.endTime,
      log_status: this.status,
      usage_time: this.usageTime,
      user_info: null
    }
    this.tabService.SendLogs(payload).subscribe((data) => {
      console.log(data);
    });
    //this.loaderService.hide();
    this.isLoading = false;

  }
}
